// // Prod
// const BASE_API_URL = "https://cwiapi.cooperwind.online/"; 

// // QA
// // const BASE_API_URL = "https://qacwiapi.cooperwind.online/";

// // Images
// const BASE_IMAGE_API_URL = "https://services.cooperwind.online/uploads/CWIImages/"; 

// // Doc
// const BASE_DOC_UPLOAD = "https://services.cooperwind.online/Fileupload/document";
// const BASE_DOCS_API_GET = "https://services.cooperwind.online/uploads/CWIDocs/";
// // Img
// const BASE_IMG_UPLOAD = "https://services.cooperwind.online/Fileupload/image";
// const BASE_IMAGE_API_GET = "https://services.cooperwind.online/uploads/CWIImages/";
// const BASE_IMG_DOC_DELETE = "https://services.cooperwind.online/Fileupload/delete";

// export { BASE_API_URL, BASE_IMAGE_API_URL, BASE_DOC_UPLOAD, BASE_DOCS_API_GET, BASE_IMG_UPLOAD, BASE_IMAGE_API_GET, BASE_IMG_DOC_DELETE };

// ================================
// API URLs
// ================================

const API_ENVIRONMENTS = {
    PROD: "https://cwiapi.cooperwind.online/",
    QA: "https://qacwiapi.cooperwind.online/",
};


// Get selected environment
const getSelectedEnvironment = () => {
    return sessionStorage.getItem("API_ENVIRONMENT") || "PROD";
};


// Get API URL based on selected environment
const getApiUrl = () => {
    const environment = getSelectedEnvironment();

    return API_ENVIRONMENTS[environment] || API_ENVIRONMENTS.PROD;
};


// Dynamic API URL
let BASE_API_URL = getApiUrl();


// Update API URL
const setApiEnvironment = (environment) => {

    if (!API_ENVIRONMENTS[environment]) {
        console.warn(`Invalid API environment: ${environment}`);
        return;
    }

    sessionStorage.setItem("API_ENVIRONMENT", environment);

    BASE_API_URL = API_ENVIRONMENTS[environment];
};


// Images
const BASE_IMAGE_API_URL =
    "https://services.cooperwind.online/uploads/CWIImages/";


// Documents
const BASE_DOC_UPLOAD =
    "https://services.cooperwind.online/Fileupload/document";

const BASE_DOCS_API_GET =
    "https://services.cooperwind.online/uploads/CWIDocs/";


// Image Upload
const BASE_IMG_UPLOAD =
    "https://services.cooperwind.online/Fileupload/image";


// Image Get
const BASE_IMAGE_API_GET =
    "https://services.cooperwind.online/uploads/CWIImages/";


// Image / Document Delete
const BASE_IMG_DOC_DELETE =
    "https://services.cooperwind.online/Fileupload/delete";


export {
    BASE_API_URL,
    setApiEnvironment,
    getSelectedEnvironment,
    getApiUrl,
    BASE_IMAGE_API_URL,
    BASE_DOC_UPLOAD,
    BASE_DOCS_API_GET,
    BASE_IMG_UPLOAD,
    BASE_IMAGE_API_GET,
    BASE_IMG_DOC_DELETE
};